import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";

import { IauiPaymentTypePayload } from "./iaui-verification.model";

@Component({
	selector: "obg-m-iaui-verification-dialog",
	templateUrl: "./iaui-verification-dialog.container.html",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IauiVerificationDialogContainer {
	title = "customer-verification.modal.title";
	constructor(private dialog: MatDialogRef<IauiVerificationDialogContainer>) {}

	onDone(paymentType: IauiPaymentTypePayload) {
		this.dialog.close(paymentType);
	}
}
